import * as constants from '../constants/constants';
import { axiosCaller } from "../utils/apiCaller";
import { ACTION, wrap, setLoading, setButtonLoading }  from './generalActions'
import { toast } from 'react-toastify';
import { ArticleInfomation ,  } from '../types/ArticleInformation.type';
import { OfferField } from '../types/offerField.type';
import {translatedText} from "../components/TranslatedText"

export const resetArticle = (): ACTION => ({
    type: constants.RESET_ARTICLE
});

const adminPath = "admin/"


export const fetchUsers = () => wrap(async (dispatch: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return await axiosCaller('GET', `${adminPath}users`).then(res => {
            dispatch({ "type": constants.FETCH_USERS, "payload": res.data.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        })
    } catch (err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
    }
}, 'FETCH_USERS')

export const fetchUsersDashboardInformation = () => wrap(async (dispatch: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return await axiosCaller('GET', `users/dashboard`).then(res => {
            dispatch({ "type": constants.FETCH_USERS_DASHBOARD_INFORMATION, "payload": res.data.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        })
    } catch (err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
    }
}, 'FETCH_USERS')

export const fetchPermissions = () => wrap(async (dispatch: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return await axiosCaller('GET', `${adminPath}permissions`).then(res => {
            dispatch({ "type": constants.FETCH_PERMISSIONS, "payload": res.data.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        })
    } catch (err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
    }
}, 'FETCH_USERS')

export const fetchUser = (userId: number) => wrap(async (dispatch: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return await axiosCaller('GET', `${adminPath}users/${userId}`).then(res => {
            dispatch({ "type": constants.FETCH_USER, "payload": res.data.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            return res.data.data
        })
    } catch (err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
    }
}, 'FETCH_USERS')

// Note: createUser action was removed — it was never wired up (CreateUserForm.tsx
// calls axiosCaller directly). The form's catch block now uses formatApiErrorMessage
// from utils/apiError.ts to surface field-level + business-code errors uniformly.

export const editUser = (userID: number, payload: any) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}users/${userID}?_method=PATCH`, payload).then((response: any) => {
            dispatch({ "type": constants.FETCH_USER, "payload": response.data.data})
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            toast.info(translatedText({id:"userEditedSuccess",defaultMessage:"Perdoruesi eshte ndryshuar!"}))
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const fetchResponsibility = (responsibilityId: number) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `${adminPath}responsibilities/${responsibilityId}`).then((res:any) => {
            dispatch({ "type": constants.FETCH_RESPONSIBILITY, "payload": res.data.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const createResponsibility = (payload: any) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}responsibilities`, payload).then((response: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            if(response.data.unique.name){
                toast.info('Ky proces eksiston!');
            }else{
                toast.success(translatedText({id:"processCreated",defaultMessage:"Procesi u krijua me sukses!"}))
            }
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const editResponsibility = (responsibilityId: number, payload: any) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}responsibilities/${responsibilityId}?_method=PATCH`, payload).then((response: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            if(response.data.unique.name){
                toast.info('Ky proces eksiston!');
            }else{
                toast.success(translatedText({id:"processUpdated",defaultMessage:"Procesi u ndryshua me sukses!"}))
            }
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const deleteResponsibility = (responsibilityId: number) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('DELETE', `${adminPath}responsibilities/${responsibilityId}`).then((response: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            if(response.data.data === false){
                toast.info(translatedText({id:"processCannotDelete",defaultMessage:"Ky proces eshte i lidhur me module tjera, nuk mund te fshihet!"}))
            }else{
                toast.success(translatedText({id:"processDeleted",defaultMessage:"Procesi u fshi me sukses!"}))
            }

        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const reorderResponsibilities = (items: Array<{ id: number; sort_order: number }>) => wrap((dispatch: any, state: any) => {
    try {
        return axiosCaller('PUT', `${adminPath}responsibilities/reorder`, { items }).then((res: any) => res?.data);
    } catch (err) {
        toast.error(translatedText({ id: 'somethingWentWrong', defaultMessage: 'Diqka nuk shkoi mire' }));
    }
}, 'REORDER_RESPONSIBILITIES_ERROR');

export const fetchMaterials = () => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `${adminPath}material`).then((res:any) => {
            dispatch({ "type": constants.FETCH_MATERIALS, "payload": res.data.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const getMaterial = (materialId: number) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `${adminPath}material/${materialId}`).then((res:any) => {
            dispatch({ "type": constants.GET_MATERIAL, "payload": res.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const createMaterial = (payload: any) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}material`, payload).then((response: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            toast.info(translatedText({id:"materialCreated",defaultMessage:"Materiali u krijua me sukses"}))
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const editMaterial = (materialId: number, payload: any) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}material/${materialId}`, payload).then((response: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            if (response?.data?.data){
                toast.info(translatedText({id:"materialUpdated",defaultMessage:"Materiali u ndryshua me sukses"}))
            }else{
                toast.error('Ky material ka artikuj ne prodhim.')
            }
            return response
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const deleteMaterial = (materialId: number) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('DELETE', `${adminPath}material/${materialId}`).then((response: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            if(!response?.data?.data){
                toast.error(translatedText({id:"materialCannotDelete",defaultMessage:"Materiali eshte ne faza te prodhimit, nuk mund te fshihet!"}))
            }else{
                toast.info(translatedText({id:"materialDeleted",defaultMessage:"Materiali u fshi me sukses!"}))
            }
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const createEquipment = (payload: any) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}mounting-equipments`, payload).then((response: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const editEquipment = (payload: any, equipmentId: number) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}mounting-equipments/${equipmentId}?_method=PATCH`, payload).then((response: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const deleteEquipment = (equipmentId: number) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('DELETE', `${adminPath}mounting-equipments/${equipmentId}`).then((response: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            if(response.data.data === false){
                return false
            }
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const getUsersForResponsibilities = () => wrap((dispatch:any, state:any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `${adminPath}responsibilities/users`).then((res:any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            dispatch({ "type": constants.FETCH_USERS_FOR_RESPONSIBILITIES, "payload": res });
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const deleteUser = (userId: number) => wrap((dispatch:any, state:any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('DELETE', `${adminPath}users/${userId}`).then((res:any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            dispatch({ "type": constants.DELETE_USER, "payload": res });
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const createUnit = (payload: any) => wrap(async (dispatch: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    return await axiosCaller('POST', `${adminPath}units`, payload).then(res => {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        dispatch({ "type": constants.CREATE_UNIT, "payload": res.data.data });
        if(res.data.unique.name){
            toast.info('Kjo njesi eksiston!');
            return
        }
        toast.success(translatedText({id:"unitCreated",defaultMessage:"Njesia u krijua me sukses!"}));
    })
    // try {
    //
    // } catch(err) {
    //     dispatch(setLoading(false));
    dispatch(setButtonLoading(false));
    //     toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    // }
}, 'CREATE_UNIT')

export const getAllDepartmentsDetailed = () => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true));
        return await axiosCaller('GET', `${adminPath}departments`).then(res => {
            dispatch({ "type": constants.GET_DEPARTMENTS_DETAILED, "payload": res.data.data });
            dispatch(setLoading(false));
        })
    } catch (err) {
        dispatch(setLoading(false));
    }
}, 'GET_DEPARTMENTS_DETAILED')

export const getAllUnitsDetailed = () => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true));
        return await axiosCaller('GET', `${adminPath}units`).then(res => {
            dispatch({ "type": constants.GET_UNITS_DETAILED, "payload": res.data.data });
            dispatch(setLoading(false));
        })
    } catch (err) {
        dispatch(setLoading(false));
    }
}, 'GET_UNITS_DETAILED')

export const getAllSuppliersDetailed = () => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true));
        // Detailed endpoint lives at /admin/suppliers/detailed (not the root)
        // because /admin/suppliers/ is already taken by the slim list used by
        // ArticleListAndCreateForm and KuBIT.
        return await axiosCaller('GET', `${adminPath}suppliers/detailed`).then(res => {
            dispatch({ "type": constants.GET_SUPPLIERS_DETAILED, "payload": res.data.data });
            dispatch(setLoading(false));
        })
    } catch (err) {
        dispatch(setLoading(false));
    }
}, 'GET_SUPPLIERS_DETAILED')

export const getAllMaterialsDetailed = () => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true));
        // Backend uses the singular `material` prefix (not `materials`) — see
        // routes/api.php and MaterialController. Detailed list lives at
        // /admin/material/detailed (placed before the {materialId} wildcard
        // in routes so Laravel doesn't route the literal segment into
        // showById()).
        return await axiosCaller('GET', `${adminPath}material/detailed`).then(res => {
            dispatch({ "type": constants.GET_MATERIALS_DETAILED, "payload": res.data.data });
            dispatch(setLoading(false));
        })
    } catch (err) {
        dispatch(setLoading(false));
    }
}, 'GET_MATERIALS_DETAILED')

export const createDepartment = (payload: any) => wrap(async (dispatch: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    return await axiosCaller('POST', `${adminPath}departments`, payload).then(res => {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        dispatch({ "type": constants.CREATE_UNIT, "payload": res.data.data });
        if(res.data.unique.name){
            toast.info('Ky repart eksiston!');
            return
        }
        toast.success(translatedText({id:"departmentCreated",defaultMessage:"Reparti u krijua me sukses!"}));
    })
    // try {
    //
    // } catch(err) {
    dispatch(setLoading(false));
    dispatch(setButtonLoading(false));
    //     toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    // }
}, 'CREATE_DEPARTMENT')

export const editUnit = (unitId: number, payload: any) => wrap(async(dispatch:any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return await axiosCaller('POST', `${adminPath}units/${unitId}?_method=PATCH`, payload).then(res => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            if(res.data.unique.name){
                toast.info('Kjo njesi eksiston!');
            }else{
                toast.success(translatedText({id:"unitUpdated",defaultMessage:"Njesia u ndryshua me sukses!"}));
            }
        })
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
    }
}, 'EDIT_UNIT')

export const editDepartment = (departmentId: number, payload: any) => wrap(async(dispatch:any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return await axiosCaller('POST', `${adminPath}departments/${departmentId}`, payload).then(res => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            if(res.data.unique.name){
                toast.info('Ky repart eksiston!');
            }else{
                toast.success(translatedText({id:"departmentUpdated",defaultMessage:"Reparti u ndryshua me sukses!"}));
            }
        })
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
    }
}, 'EDIT_UNIT')

export const deleteUnit = (unitId: number) => wrap(async(dispatch:any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return await axiosCaller('DELETE', `${adminPath}units/${unitId}`).then(res => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            dispatch({ "type": constants.DELETE_UNIT, "payload": res.data.data });
            toast.info(translatedText({id:"unitDeleted",defaultMessage:"Njesia u fshi me sukses"}));
        })
    } catch (err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
    }
}, 'DELETE_UNIT')

export const deleteDepartment = (departmentId: number) => wrap(async(dispatch:any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return await axiosCaller('DELETE', `${adminPath}departments/${departmentId}`).then(res => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            toast.info(translatedText({id:"departmentDeleted",defaultMessage:"Reparti u fshi me sukses"}));
        })
    } catch (err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
    }
}, 'DELETE_UNIT')

// KuBIT push_on_save runs inside the save request. A rejection used to vanish into
// kubit_sync_log while the user was told "saved successfully" — so an edit could
// silently never reach KuBIT. The backend now returns the FINAL push outcome on the
// save response; warn when it failed so the user knows (and why) instead of guessing.
const warnIfKubitPushFailed = (res: any) => {
    const push = res?.data?.kubitPush;
    if (push && push.ok === false) {
        toast.warning(translatedText({
            id: "kubitPushFailed",
            defaultMessage: "U ruajt ne Mika, por KuBIT nuk e pranoi: {reason}",
            values: { reason: push.message || '' },
        }), { autoClose: 10000 });
    }
};

export const createArticle = (articleInformation: ArticleInfomation) => wrap((dispatch:any, state:any) => {
    // dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        // Backend returns HTTP 200 in BOTH success and "unique key already used"
        // cases — the discriminator is `res.data.unique.code` / `res.data.unique.name`.
        // We return true/false so the caller (ArticleCreatePage) can keep the
        // form open on a soft conflict instead of navigating away and wiping
        // the user's work. Mirrors editArticle's contract.
        return axiosCaller('POST', `${adminPath}articles`, articleInformation, {"Content-Type": "multipart/form-data"}, true).then((res:any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            if(res.data.unique?.code){
                toast.info(translatedText({id:"articleCodeUsed",defaultMessage:"Kodi i produktit eshte perdorur me pare!"}));
                return false;
            }
            // Only dispatch + success-toast when the create actually happened.
            dispatch({ "type": constants.CREATE_ARTICLE, "payload": res.data.data });
            toast.success(translatedText({id:"articleCreated",defaultMessage:"Artikulli u krijua me sukses!"}));
            warnIfKubitPushFailed(res);
            return true;
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
        return false;
    }
}, 'CREATE_ARTICLE');

// Bulk Excel import of articles. Per-company gated (companyProfile.articlesImportEnabled)
// on the UI; the route itself is admin/fullPrivileges. Returns the backend summary
// ({ success, summary: { created, updated, skipped, units_created, production_stages,
// production_stages_attached } }) so the caller can toast the result. Returns null on error
// (already toasted here).
export const importArticles = (formData: FormData) => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        const res: any = await axiosCaller('POST', `${adminPath}articles/import-excel`, formData, {"Content-Type": "multipart/form-data"}, true);
        return res?.data ?? null;
    } catch (err: any) {
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
        return null;
    } finally {
        dispatch(setButtonLoading(false));
    }
}, 'IMPORT_ARTICLES');

export const fetchArticleTypes = () => wrap((dispatch:any, state:any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `${adminPath}types`).then((res:any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            dispatch({ "type": constants.FETCH_ARTICLE_TYPES, "payload": res.data.data });
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'FETCH_ARTICLE_TYPE');

export const fetchArticleType = (articleTypeId:number) => wrap((dispatch:any, state:any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `${adminPath}types/${articleTypeId}/responsibilities`).then((res:any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            dispatch({ "type": constants.FETCH_ARTICLE_TYPE, "payload": res.data.data });
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const deleteArticleType = (articleTypeId:number) => wrap((dispatch:any, state:any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('DELETE', `${adminPath}types/${articleTypeId}`).then((res: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const fetchArticle = (articleTypeId:number) => wrap((dispatch:any, state:any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `articles/${articleTypeId}/responsibilities`).then((res:any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            dispatch({ "type": constants.FETCH_ARTICLE, "payload": res.data.data });
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const editArticle = (articleId:number, articleInformation: any) => wrap((dispatch:any, state:any) => {
    // dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}articles/${articleId}?_method=PATCH`, articleInformation, {"Content-Type": "multipart/form-data"}, true).then((res:any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            if(res.data.data === false){
                toast.error(translatedText({id:"articleCannotEdit",defaultMessage:"Artikulli eshte ne faza te prodhimit, nuk mund te editohet!"}));
                return false
            }else{
                dispatch({ "type": constants.EDIT_ARTICLE, "payload": res.data.data });
                toast.success(translatedText({id:"articleUpdated",defaultMessage:"Artikulli u editua me sukses!"}));
                warnIfKubitPushFailed(res);
                return true
            }
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const deleteArticle = (articleId:number) => wrap((dispatch:any, state:any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('DELETE', `${adminPath}articles/${articleId}`).then((res:any) => {
            if(res?.data?.data === false){
                toast.error(translatedText({id:"articleCannotDelete",defaultMessage:"Artikulli eshte ne faza te prodhimit, nuk mund te fshihet!"}))
            }else{
                toast.info(translatedText({id:"articleDeleted",defaultMessage:"Artikulli u fshi me sukses!"}))
            }
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const createOfferField = (payload: OfferField) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}dynamic-offers`, payload).then((res: any) => {
            toast.success('Fusha u krijua me sukses!');
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const getOfferField = (offerFieldId: number) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `${adminPath}dynamic-offers/${offerFieldId}`).then((res: any) => {
            dispatch({ "type": constants.GET_OFFER_FIELD, "payload": res.data.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const editOfferField = (offerFieldId: number, payload: OfferField) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}dynamic-offers/${offerFieldId}?_method=PATCH`, payload).then((res: any) => {
            toast.success('Fusha u editua me sukses!');
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const getImpressionQuestions = () => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `${adminPath}impression-questions`).then((res: any) => {
            dispatch({ "type": constants.GET_IMPRESSION_QUESTIONS, "payload": res.data.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const clearImpressionQuestion = (): ACTION => ({
    type: constants.SET_NAME_SURNAME_OFFER,
    payload: null
});

export const createImpressionQuestion = (payload) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}impression-questions`, payload).then((res: any) => {
            toast.success('Pyetja u editua me sukses!');
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const editImpressionQuestion = (impressionQuestionId: number, payload) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}impression-questions/${impressionQuestionId}`, payload).then((res: any) => {
            toast.success('Pyetja u editua me sukses!');
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'CREATE_OFFER_ERROR');

export const clearOfferField = (): ACTION => ({
    type: constants.CLEAR_OFFER_FIELD
})

export const saveConditionsForOffer = (payload: {conditions: string; conditionsExport?: string}, offerConditionId?: number) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}offer-conditions${offerConditionId ? `/${offerConditionId}?_method=PATCH` : '' }`, payload).then((res: any) => {
            toast.success(translatedText({id:"conditionsSaved",defaultMessage:"Kushtet u ruajten me sukses!"}));
            return axiosCaller('GET', `offer/conditions`).then((res: any) => {
                dispatch({ "type": constants.GET_OFFER_CONDITIONS, "payload": res.data.data });
                dispatch(setLoading(false));
                dispatch(setButtonLoading(false));
            });
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'SAVE_OFFER_CONDITIONS_ERROR');

export const getOfferConditions = () => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `offer/conditions`).then((res: any) => {
            dispatch({ "type": constants.GET_OFFER_CONDITIONS, "payload": res.data.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'GET_OFFER_CONDITIONS_ERROR');

export const getAuditLogs = () => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `${adminPath}audits/show`).then((res: any) => {
            dispatch({ "type": constants.GET_AUDIT_LOGS, "payload": res.data.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'GET_OFFER_CONDITIONS_ERROR');

export const getColorPalettes = () => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `${adminPath}color-palette`).then((res: any) => {
            dispatch({ "type": constants.GET_COLOR_PALETTES, "payload": res.data.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'GET_OFFER_CONDITIONS_ERROR');

export const createColorPalette = (payload: {colorPalette: string}) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}color-palette`,payload ).then((res: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'GET_OFFER_CONDITIONS_ERROR');

export const editColorPalette = (payload: {colorPalette: string}, colorPaletteId: number) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('PATCH', `${adminPath}color-palette/${colorPaletteId}`,payload ).then((res: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'GET_OFFER_CONDITIONS_ERROR');

export const deleteColorPalette = (colorPaletteId: number) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('DELETE', `${adminPath}color-palette/${colorPaletteId}` ).then((res: any) => {
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'GET_OFFER_CONDITIONS_ERROR');


export const getSuppliers = () => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('GET', `${adminPath}suppliers` ).then((res: any) => {
            dispatch({ "type": constants.GET_SUPPLIERS, "payload": res.data.data });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'GET_OFFER_CONDITIONS_ERROR');

export const saveSupplier = (payload) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}suppliers`, payload).then((res: any) => {
            toast.success(translatedText({id:"supplierCreated",defaultMessage:"Furnitori u krijua me sukses!"}));
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'GET_OFFER_CONDITIONS_ERROR');

export const editSupplier = (supplierId ,payload) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('POST', `${adminPath}suppliers/${supplierId}`, payload).then(() => {
            toast.success(translatedText({id:"supplierUpdated",defaultMessage:"Furnitori u ndyshua me sukses!"}))
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'GET_OFFER_CONDITIONS_ERROR');


export const deleteSupplier = (supplierId) => wrap((dispatch: any, state: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        return axiosCaller('DELETE', `${adminPath}suppliers/${supplierId}`).then(() => {
            toast.info(translatedText({id:"supplierDeleted",defaultMessage:"Furnitori u fshi me sukses!"}))
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
        });
    } catch(err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'GET_OFFER_CONDITIONS_ERROR');

export const updateCompanyProfile = (formData: FormData) => wrap(async (dispatch: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        const res = await axiosCaller('POST', `${adminPath}company-profile`, formData, {"Content-Type": "multipart/form-data"}, true);
        dispatch({ type: constants.FETCH_COMPANY_PROFILE, payload: res.data.data });
        toast.success(translatedText({id:"profileSaved",defaultMessage:"Profili u ruajt me sukses!"}));
    } catch (err) {
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    } finally {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
    }
}, 'UPDATE_COMPANY_PROFILE_ERROR');

export const updateOfferPdfSettings = (formData: FormData) => wrap(async (dispatch: any) => {
    dispatch(setLoading(true));
    dispatch(setButtonLoading(true));
    try {
        await axiosCaller('POST', `${adminPath}offer-settings`, formData, {"Content-Type": "multipart/form-data"}, true);
        toast.success(translatedText({id:"settingsSaved",defaultMessage:"Konfigurimet u ruajten me sukses!"}));
    } catch (err) {
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    } finally {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
    }
}, 'UPDATE_OFFER_PDF_SETTINGS_ERROR');

// ----- KuBIT integration -----

export const getKubitSettings = () => wrap(async (dispatch: any) => {
    dispatch(setLoading(true));
    try {
        const res: any = await axiosCaller('GET', `${adminPath}integrations/kubit`);
        const payload = res?.data?.data ?? null;
        dispatch({ type: constants.GET_KUBIT_SETTINGS, payload });
        dispatch(setLoading(false));
        return payload;
    } catch (err) {
        dispatch(setLoading(false));
        return null;
    }
}, 'GET_KUBIT_SETTINGS');

export const saveKubitSettings = (payload: any, isCreate: boolean) => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        const method = isCreate ? 'POST' : 'PUT';
        const res: any = await axiosCaller(method, `${adminPath}integrations/kubit`, payload);
        const data = res?.data?.data ?? res?.data ?? null;
        dispatch({ type: constants.SAVE_KUBIT_SETTINGS, payload: data });
        dispatch(setButtonLoading(false));
        return true;
    } catch (err: any) {
        dispatch(setButtonLoading(false));
        const message = err?.response?.data?.message
            || translatedText({ id: 'integrations.kubit.toast.error', defaultMessage: 'Something went wrong.' });
        toast.error(message);
        return false;
    }
}, 'SAVE_KUBIT_SETTINGS');

export const testKubitConnection = (payload: { apiKey: string; apiBaseUrl: string }) => wrap(async (dispatch: any) => {
    try {
        const res: any = await axiosCaller('POST', `${adminPath}integrations/kubit/test`, payload);
        return {
            ok: !!res?.data?.ok,
            httpStatus: res?.data?.http_status,
            message: res?.data?.message
        };
    } catch (err: any) {
        return {
            ok: false,
            httpStatus: err?.response?.status,
            message: err?.response?.data?.message || 'Network error'
        };
    }
}, 'TEST_KUBIT_CONNECTION');

export const disconnectKubit = () => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        const res: any = await axiosCaller('DELETE', `${adminPath}integrations/kubit`);
        const data = res?.data?.data ?? res?.data ?? null;
        dispatch({ type: constants.DISCONNECT_KUBIT, payload: data });
        dispatch(setButtonLoading(false));
        return true;
    } catch (err: any) {
        dispatch(setButtonLoading(false));
        const message = err?.response?.data?.message
            || translatedText({ id: 'integrations.kubit.toast.error', defaultMessage: 'Something went wrong.' });
        toast.error(message);
        return false;
    }
}, 'DISCONNECT_KUBIT');

export const triggerKubitSync = () => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        const res: any = await axiosCaller('POST', `${adminPath}integrations/kubit/sync`, {});
        dispatch({ type: constants.TRIGGER_KUBIT_SYNC, payload: res?.data ?? null });
        dispatch(setButtonLoading(false));
        return res?.data ?? null;
    } catch (err: any) {
        dispatch(setButtonLoading(false));
        if (err?.response?.status === 409) {
            return { locked: true, message: err?.response?.data?.message };
        }
        const message = err?.response?.data?.message
            || translatedText({ id: 'integrations.kubit.toast.error', defaultMessage: 'Something went wrong.' });
        toast.error(message);
        return null;
    }
}, 'TRIGGER_KUBIT_SYNC');

export const reconcileKubitEntities = () => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        const res: any = await axiosCaller('POST', `${adminPath}integrations/kubit/reconcile/entities`, {});
        const data = res?.data ?? null;
        dispatch({ type: constants.RECONCILE_KUBIT_ENTITIES, payload: data });
        dispatch(setButtonLoading(false));
        return data;
    } catch (err: any) {
        dispatch(setButtonLoading(false));
        const message = err?.response?.data?.message
            || translatedText({ id: 'integrations.kubit.toast.error', defaultMessage: 'Something went wrong.' });
        toast.error(message);
        return null;
    }
}, 'RECONCILE_KUBIT_ENTITIES');

export const pushKubitEntities = () => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        const res: any = await axiosCaller('POST', `${adminPath}integrations/kubit/push/entities`, {});
        const data = res?.data ?? null;
        dispatch({ type: constants.PUSH_KUBIT_ENTITIES, payload: data });
        dispatch(setButtonLoading(false));
        return data;
    } catch (err: any) {
        dispatch(setButtonLoading(false));
        const message = err?.response?.data?.message
            || translatedText({ id: 'integrations.kubit.toast.error', defaultMessage: 'Something went wrong.' });
        toast.error(message);
        return null;
    }
}, 'PUSH_KUBIT_ENTITIES');

export const pushKubitItems = () => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        const res: any = await axiosCaller('POST', `${adminPath}integrations/kubit/push/items`, {});
        const data = res?.data ?? null;
        dispatch({ type: constants.PUSH_KUBIT_ITEMS, payload: data });
        dispatch(setButtonLoading(false));
        return data;
    } catch (err: any) {
        dispatch(setButtonLoading(false));
        const message = err?.response?.data?.message
            || translatedText({ id: 'integrations.kubit.toast.error', defaultMessage: 'Something went wrong.' });
        toast.error(message);
        return null;
    }
}, 'PUSH_KUBIT_ITEMS');

export const pushKubitSuppliers = () => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        const res: any = await axiosCaller('POST', `${adminPath}integrations/kubit/push/suppliers`, {});
        const data = res?.data ?? null;
        dispatch({ type: constants.PUSH_KUBIT_SUPPLIERS, payload: data });
        dispatch(setButtonLoading(false));
        return data;
    } catch (err: any) {
        dispatch(setButtonLoading(false));
        const message = err?.response?.data?.message
            || translatedText({ id: 'integrations.kubit.toast.error', defaultMessage: 'Something went wrong.' });
        toast.error(message);
        return null;
    }
}, 'PUSH_KUBIT_SUPPLIERS');

// Push a SINGLE Mika offer to KuBIT as a sale order (proforma). Unlike the
// bulk push actions above, this is offer-scoped and returns a structured
// result the calling component branches on (mirrors triggerKubitSync's 409
// handling): on success { ok:true, created, already_pushed, sale_order_id,
// skipped_lines }; on a 422 { ok:false, reason, message, unmapped_articles }.
// No reducer case — the result is per-call ephemeral.
export const pushKubitSaleOrder = (offerId: number, skipUnsynced: boolean = false) => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        // skipUnsynced = the offer UI's "push without them" retry: push even when some
        // raw-material components aren't synced to KuBIT (they're dropped from the recipe).
        const res: any = await axiosCaller('POST', `${adminPath}integrations/kubit/push/sale-order/${offerId}`, { skipUnsynced });
        const data = res?.data ?? {};
        dispatch({ type: constants.PUSH_KUBIT_SALE_ORDER, payload: data });
        dispatch(setButtonLoading(false));
        return { ok: true, ...data };
    } catch (err: any) {
        dispatch(setButtonLoading(false));
        const data = err?.response?.data;
        // Return a structured result for ALL failure paths (no toast here) so the
        // calling component owns the messaging — the 422 body carries a precise,
        // actionable {reason, message, unmapped_articles/unsynced_components}; other
        // errors fall back to a generic message. Avoids a double toast.
        return {
            ok: false,
            reason: data?.reason ?? 'request_failed',
            message: data?.message
                || translatedText({ id: 'integrations.kubit.toast.error', defaultMessage: 'Something went wrong.' }),
            unmapped_articles: data?.unmapped_articles ?? [],
            unsynced_components: data?.unsynced_components ?? [],
        };
    }
}, 'PUSH_KUBIT_SALE_ORDER');

export const reconcileKubitSuppliers = () => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        const res: any = await axiosCaller('POST', `${adminPath}integrations/kubit/reconcile/suppliers`, {});
        const data = res?.data ?? null;
        dispatch({ type: constants.RECONCILE_KUBIT_SUPPLIERS, payload: data });
        dispatch(setButtonLoading(false));
        return data;
    } catch (err: any) {
        dispatch(setButtonLoading(false));
        const message = err?.response?.data?.message
            || translatedText({ id: 'integrations.kubit.toast.error', defaultMessage: 'Something went wrong.' });
        toast.error(message);
        return null;
    }
}, 'RECONCILE_KUBIT_SUPPLIERS');

export const reconcileKubitItems = () => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        const res: any = await axiosCaller('POST', `${adminPath}integrations/kubit/reconcile/items`, {});
        const data = res?.data ?? null;
        dispatch({ type: constants.RECONCILE_KUBIT_ITEMS, payload: data });
        dispatch(setButtonLoading(false));
        return data;
    } catch (err: any) {
        dispatch(setButtonLoading(false));
        const message = err?.response?.data?.message
            || translatedText({ id: 'integrations.kubit.toast.error', defaultMessage: 'Something went wrong.' });
        toast.error(message);
        return null;
    }
}, 'RECONCILE_KUBIT_ITEMS');

export const resetKubitCursor = () => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        const res: any = await axiosCaller('POST', `${adminPath}integrations/kubit/reset-cursor`, {});
        const data = res?.data?.data ?? res?.data ?? null;
        dispatch({ type: constants.RESET_KUBIT_CURSOR, payload: data });
        dispatch(setButtonLoading(false));
        return true;
    } catch (err: any) {
        dispatch(setButtonLoading(false));
        const message = err?.response?.data?.message
            || translatedText({ id: 'integrations.kubit.toast.error', defaultMessage: 'Something went wrong.' });
        toast.error(message);
        return false;
    }
}, 'RESET_KUBIT_CURSOR');

export const purgeKubitMappings = () => wrap(async (dispatch: any) => {
    dispatch(setButtonLoading(true));
    try {
        const res: any = await axiosCaller('DELETE', `${adminPath}integrations/kubit/mappings`);
        const deleted = res?.data?.deleted ?? 0;
        dispatch({ type: constants.PURGE_KUBIT_MAPPINGS, payload: deleted });
        dispatch(setButtonLoading(false));
        return deleted;
    } catch (err: any) {
        dispatch(setButtonLoading(false));
        const message = err?.response?.data?.message
            || translatedText({ id: 'integrations.kubit.toast.error', defaultMessage: 'Something went wrong.' });
        toast.error(message);
        return null;
    }
}, 'PURGE_KUBIT_MAPPINGS');

export const getKubitDiscovery = () => wrap(async (dispatch: any) => {
    try {
        const res: any = await axiosCaller('GET', `${adminPath}integrations/kubit/discovery`);
        const payload = res?.data?.data ?? { countryIds: [], entityTypeIds: [], phonePrefixIds: [] };
        dispatch({ type: constants.GET_KUBIT_DISCOVERY, payload });
        return payload;
    } catch (err) {
        return null;
    }
}, 'GET_KUBIT_DISCOVERY');

export const getKubitSyncLog = (filters: any = {}) => wrap(async (dispatch: any) => {
    try {
        const params = new URLSearchParams();
        if (filters.resourceType) params.append('resourceType', filters.resourceType);
        if (filters.direction) params.append('direction', filters.direction);
        if (filters.status) params.append('status', filters.status);
        if (filters.perPage) params.append('perPage', String(filters.perPage));
        const qs = params.toString();
        const url = `${adminPath}integrations/kubit/log${qs ? '?' + qs : ''}`;
        const res: any = await axiosCaller('GET', url);
        dispatch({ type: constants.GET_KUBIT_SYNC_LOG, payload: res?.data ?? { data: [] } });
        return res?.data ?? null;
    } catch (err) {
        return null;
    }
}, 'GET_KUBIT_SYNC_LOG');

// Live-progress polling endpoint. Called by KubitIntegration's polling
// effect every ~800ms while a sync is in flight, plus once on component
// mount to detect any active run from a prior browser session. Errors are
// swallowed (returning null) because polling failures should NOT block the
// UI — the next tick will retry. The reducer treats null as "no change".
export const getKubitSyncProgress = () => wrap(async (dispatch: any) => {
    try {
        const res: any = await axiosCaller('GET', `${adminPath}integrations/kubit/sync/progress`);
        const payload = res?.data ?? { run: null, steps: [] };
        dispatch({ type: constants.GET_KUBIT_SYNC_PROGRESS, payload });
        return payload;
    } catch (err) {
        return null;
    }
}, 'GET_KUBIT_SYNC_PROGRESS');

// Paginated history of past sync runs. Powers the "Aktiviteti i sinkronizimit"
// list. Steps are NOT included here — clicking a row triggers
// getKubitSyncRunDetail to fetch the step breakdown on demand.
export const getKubitSyncRuns = (filters: { perPage?: number; page?: number } = {}) => wrap(async (dispatch: any) => {
    try {
        const params = new URLSearchParams();
        if (filters.perPage) params.append('perPage', String(filters.perPage));
        if (filters.page) params.append('page', String(filters.page));
        const qs = params.toString();
        const url = `${adminPath}integrations/kubit/sync/runs${qs ? '?' + qs : ''}`;
        const res: any = await axiosCaller('GET', url);
        const payload = res?.data ?? { data: [], meta: null };
        dispatch({ type: constants.GET_KUBIT_SYNC_RUNS, payload });
        return payload;
    } catch (err) {
        return null;
    }
}, 'GET_KUBIT_SYNC_RUNS');

// On-demand fetch of a single past run's full step breakdown. The reducer
// caches by run_uuid so re-expanding a previously-viewed row is instant.
export const getKubitSyncRunDetail = (runUuid: string) => wrap(async (dispatch: any) => {
    try {
        const res: any = await axiosCaller('GET', `${adminPath}integrations/kubit/sync/runs/${encodeURIComponent(runUuid)}`);
        const payload = res?.data ?? { run: null, steps: [] };
        dispatch({ type: constants.GET_KUBIT_SYNC_RUN_DETAIL, payload: { runUuid, ...payload } });
        return payload;
    } catch (err) {
        return null;
    }
}, 'GET_KUBIT_SYNC_RUN_DETAIL');
